import { render, staticRenderFns } from "./ModalVerItensGrupo.vue?vue&type=template&id=de59268e&"
import script from "./ModalVerItensGrupo.vue?vue&type=script&lang=js&"
export * from "./ModalVerItensGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports